<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    *ngIf="!isRightSideContent"
    [class]="extraClass"
    [title]="'Scan Your Property'"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    <ng-container *ngIf="loaded">

      <ng-container [ngSwitch]="modalFlow">

        <tidy-error-message
          *ngIf="errorMessage"
          [text]="errorMessage" />

        <ng-container *ngSwitchCase="'secondModal'">

          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'TIDY has the easiest way to make a map of your property, taking less than 5 minutes of your time.'" />
          </tidy-row>

          <tidy-card>
            <tidy-row>
              <tidy-text
                [header]="'Please tell us more about:'" />
            </tidy-row>
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [body]="addressName" />
            </tidy-row>
            <form [formGroup]="form">
              <tidy-row class="field-top-padding field-bottom-padding">
                <tidy-select
                  [icon]="'assets/svg/bed.svg'"
                  [label]="'Number of Bedrooms'"
                  [form]="form.controls.beds"
                  formControlName="beds"
                  [items]="roomOptions" />
              </tidy-row>
              <tidy-row class="field-bottom-padding">
                <tidy-select
                  [icon]="'assets/svg/bed.svg'"
                  [label]="'Number of Bathrooms'"
                  [form]="form.controls.baths"
                  formControlName="baths"
                  [items]="roomOptions" />
              </tidy-row>
              <tidy-row>
                <tidy-select
                  [icon]="'assets/svg/home.svg'"
                  [label]="'Number of Floors'"
                  [form]="form.controls.floors"
                  formControlName="floors"
                  [items]="floorOptions" />
              </tidy-row>
            </form>
          </tidy-card>
          <tidy-button
            [text]="'Next'"
            [action]="boundSecondModal"
            class="primary" />
        </ng-container>

        <ng-container *ngSwitchCase="'thirdModal'">
          <tidy-card>
            <tidy-row class="extra-bottom-padding vertical-align-center">
              <tidy-image
                [src]="'assets/svg/home.svg'"
                class="header-size" />
              <tidy-text
                [header]="'Confirm Your Rooms'" />
            </tidy-row>
            <ng-container *ngFor="let floor of floors; trackBy: trackByFloor">
              <ng-container *ngIf="floor">
                <tidy-row class="vertical-align-center" *ngFor="let room of floor; trackBy: trackByRoom">
                  <tidy-image
                    [src]="'assets/img/icons/rooms/' + room?.icon + '.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="room?.name" />
                </tidy-row>
              </ng-container>
            </ng-container>
            <tidy-row class="extra-top-padding">
              <tidy-text
                [body]="'Edit Rooms'"
                (action)="goToEditRooms()"
                class="link" />
            </tidy-row>
          </tidy-card>
          <tidy-button
            [text]="'Next'"
            [action]="boundFourthModal"
            class="primary" />
        </ng-container>

        <ng-container *ngSwitchCase="'confirmMap'">
          <ng-container *ngIf="!isImageLoading">
            <tidy-card style="padding-bottom: 0px">
              <tidy-row class="extra-bottom-padding vertical-align-center">
                <tidy-image
                  [src]="'assets/svg/navigate-circle.svg'"
                  class="header-size" />
                <tidy-text
                  [header]="'Confirm Your Location'" />
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [body]="'Does this show your property?'" />
              </tidy-row>
              <div style="margin-right: -15px; margin-left: -15px" *ngIf="!isImageLoading">
                <img [src]="mapToShow"
                  alt="map">
              </div>
            </tidy-card>
            <ng-container *ngIf="rejectionAlert">
              <tidy-card>
                <tidy-row>
                  <tidy-text
                    [body]="'Right now, we require a satellite image of your home to continue. We hope to support situations where your property is not shown in the future. We apologize for the inconvenience. If you have any feedback for us, please'" /><span>&nbsp;</span>
                  <tidy-text
                    (action)="goToConcierge()"
                    [body]="'tap here'"
                    class="link" />
                  <tidy-text
                  [body]="'.'" />
                </tidy-row>
              </tidy-card>
            </ng-container>
            <tidy-button
              [text]="'Yes'"
              [action]="boundSubmitMap"
              class="primary" />
            <tidy-button
              [text]="'No'"
              [action]="boundRejectMap"
              class="secondary" />
          </ng-container>

          <ng-container *ngIf="isImageLoading">
            <tidy-row>
              <ion-item>
                <ion-thumbnail slot="start" style="width: 339px; height: 339px">
                  <ion-skeleton-text animated />
                </ion-thumbnail>
              </ion-item>
            </tidy-row>
          </ng-container>

        </ng-container>
      </ng-container>

    </ng-container>
  </tidy-wrapper>
</ng-template>

<ng-container *ngIf="!isRightSideContent">
  <app-scroll-wrapper [templateContent]="content" />
</ng-container>

<ng-container *ngIf="isRightSideContent">
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
</ng-container>
